// Lightweight, project-styled skeleton blocks used while data loads.
// Inline classes match the existing "hairline" + "bone/card" aesthetic so the
// loading state feels native, not generic.

export const SkeletonLine = ({ width = "100%", className = "" }) => (
  <div
    className={`h-3 bg-secondary/60 animate-pulse ${className}`}
    style={{ width }}
  />
);

export const SkeletonCard = () => (
  <div className="hairline border-l-0 border-t-0 p-7 bg-card space-y-4" data-testid="skeleton-card">
    <div className="flex items-start justify-between">
      <div className="space-y-2 flex-1">
        <SkeletonLine width="40%" />
        <SkeletonLine width="70%" className="h-5" />
      </div>
      <div className="h-12 w-12 bg-secondary/60 animate-pulse" />
    </div>
    <SkeletonLine width="100%" />
    <SkeletonLine width="85%" />
    <div className="h-1 bg-secondary animate-pulse" />
    <div className="flex justify-between">
      <SkeletonLine width="30%" />
      <SkeletonLine width="20%" />
    </div>
  </div>
);

export const SkeletonGrid = ({ count = 4, cols = "md:grid-cols-2" }) => (
  <div className={`grid ${cols} gap-0 hairline border-r-0 border-b-0`}>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);

export const SkeletonRow = () => (
  <div className="hairline p-3 bg-card space-y-2" data-testid="skeleton-row">
    <SkeletonLine width="35%" />
    <SkeletonLine width="80%" className="h-4" />
    <SkeletonLine width="40%" />
  </div>
);
